module.exports = __webpack_public_path__ + "static/media/GBR.8b24d875.png";